<!-- Comments Section -->
<div [formGroup]="formGroup()">
  <!-- Legacy comment (non-freezeV2 or reschedule mode) -->
  @if (showLegacyComment) {
    <div class="mb-4 mt-2" data-testid="comment-section">
      <label class="block text-sm text-700 mb-2 font-semibold" data-testid="comment-label">
        {{ 'FREEZE.FREEZE_SIDEBAR.COMMENT' | translate }}
      </label>
      <textarea
        pTextarea
        class="w-full"
        rows="4"
        formControlName="comment"
        [placeholder]="'FREEZE.FREEZE_SIDEBAR.COMMENT_PLACEHOLDER' | translate"
        aria-label="freeze-comment-textarea"
        data-testid="freeze-comment-textarea"
      ></textarea>
      <small class="text-600 mt-1 block">
        {{ 'FREEZE.FREEZE_SIDEBAR.COMMENT_HELP' | translate }}
      </small>
    </div>
  }

  <!-- Simple comment for reschedule/stop/cancel modes -->
  @if (isSimpleCommentMode) {
    <div class="mb-4 mt-2" data-testid="simple-comment-section">
      <label class="block text-sm text-700 mb-2 font-semibold" data-testid="comment-label">
        {{ 'FREEZE.FREEZE_SIDEBAR.COMMENT' | translate }}
      </label>
      <textarea
        pTextarea
        class="w-full"
        rows="4"
        formControlName="comment"
        [placeholder]="'FREEZE.FREEZE_SIDEBAR.COMMENT_PLACEHOLDER' | translate"
        aria-label="comment-textarea"
        data-testid="comment-textarea"
      ></textarea>
    </div>
  }

  <!-- Full comments (freezeV2Flow and not reschedule/stop/cancel) -->
  @if (showFullComments) {
    <div class="mb-4 mt-2" data-testid="comments-section">
      <h5 class="text-base font-semibold text-900 mb-3">Comments</h5>

      <!-- Client Visible Comments -->
      <div class="mb-4">
        <label
          class="block text-sm text-700 mb-2 font-semibold"
          data-testid="client-visible-comments-label"
        >
          {{ 'FREEZE.FREEZE_SIDEBAR.CLIENT_VISIBLE_COMMENTS' | translate }} *
        </label>
        <textarea
          pTextarea
          class="w-full"
          rows="4"
          formControlName="clientVisibleComments"
          [placeholder]="'FREEZE.FREEZE_SIDEBAR.CLIENT_VISIBLE_COMMENTS_PLACEHOLDER' | translate"
          aria-label="client-visible-comments-textarea"
          data-testid="client-visible-comments-textarea"
        ></textarea>
        @if (clientVisibleControl?.touched && clientVisibleControl?.invalid) {
          <app-error-msg
            [errors]="clientVisibleControl?.errors"
            [fieldLabel]="'FREEZE.FREEZE_SIDEBAR.CLIENT_VISIBLE_COMMENTS' | translate"
            data-testid="client-visible-comments-error"
          />
        }
      </div>

      <!-- Internal Staff Comments -->
      <div>
        <label
          class="block text-sm text-700 mb-2 font-semibold"
          data-testid="internal-comments-label"
        >
          {{ 'FREEZE.FREEZE_SIDEBAR.INTERNAL_COMMENTS' | translate }}
        </label>
        <textarea
          pTextarea
          class="w-full"
          rows="4"
          formControlName="internalComments"
          [placeholder]="'FREEZE.FREEZE_SIDEBAR.INTERNAL_COMMENTS_PLACEHOLDER' | translate"
          aria-label="internal-comments-textarea"
          data-testid="internal-comments-textarea"
        ></textarea>
        <small class="text-600 mt-1 block">
          {{ 'FREEZE.FREEZE_SIDEBAR.INTERNAL_COMMENTS_HELP' | translate }}
        </small>
      </div>
    </div>
  }
</div>
